import Translation from './translation';

export default class TranslationSimple extends Translation {

  shouldEnableInput(inputLang){
    const formStatus = this.getFormStatus();
    const checkbox = formStatus.srcLang === inputLang ? formStatus.srcLangCheckbox : formStatus.destLangCheckbox;
    return checkbox.checked && checkbox.enabled;
  }

  shouldEnableTranslationButton(inputContent){

    const formStatus = this.getFormStatus();

    // One or both checkboxes are disabled.
    if(!formStatus.srcLangCheckbox.enabled || !formStatus.destLangCheckbox.enabled){
      return false;
    }

    // One or both checkboxes are unchecked.
    if(!formStatus.srcLangCheckbox.checked || !formStatus.destLangCheckbox.checked){
      return false;
    }
    
    return inputContent.length > 0;    
  }

  shouldEnableLanguageDirectionToggleButton(){

    const formStatus = this.getFormStatus();

    // One or both checkboxes are disabled.
    if(!formStatus.srcLangCheckbox.enabled || !formStatus.destLangCheckbox.enabled){
      return false;
    }

    // One or both checkboxes are unchecked.
    if(!formStatus.srcLangCheckbox.checked || !formStatus.destLangCheckbox.checked){
      return false;
    }

    return true;
  }
}
